<template>
<div>
  <div class="layout-header" style="z-index: 99;" ref="warningLayoutHeader">
    <div class="infor-layout-header mb20">
      <span class="title">异常告警历史详情<span @mouseenter="showWarningText = !showWarningText" @mouseleave="showWarningText = !showWarningText" class="showWarningText">(查看警告类型)</span></span>
      <p style="margin-right: 0.625rem">
        <el-button type="danger" size="small" @click="closeHistory">关闭</el-button>
      </p>
    </div>
    <el-row type="flex" class="row-bg abh row-bg-self" justify="space-between">
      <el-col :span="24">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="品牌名称：">
            <el-select class="w120px" v-model="formInline.brandId" :size="size" placeholder="">
              <el-option :label="item.brandName" :value="item.brandId" v-for="item in companyDataWithAll" :key="'company'+item.brandId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆编号">
            <el-input class="w120px" v-model="formInline.bikeId" :size="size" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="车辆类型：">
            <el-select class="w120px" v-model="formInline.bikeType" :size="size" placeholder="">
              <el-option :label="item.label" :value="item.value" v-for="item in bikeTypeList" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="warning-show" label="警告类型：">
            <el-select class="w120px" v-model="formInline.abnormalType" :size="size" placeholder="">
              <el-option :label="item.label" :value="item.key" v-for="item in abnormalTypes" :key="'types'+item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间：">
            <el-date-picker class="w250px" :size="size" v-model="formInline.updateTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="onSearch" type="primary" :size="size">查询</el-button>
            <el-button @click="onReset" :size="size">重置</el-button>
            <el-button v-show="checkUserAuth(7, 10)" @click="onExport" :size="size">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="warning-text" v-show="showWarningText">
      <p class="mb3">警告类型说明：</p>
      <p>站外还车 ：共享单车企业上传的还车数据出现没有站点编号或站点编号不在平台数据库；</p>
      <p>违法设备 ：共享单车企业上传的还车数据有站点编号,且站点编号为蓝牙站点,上传的MAC地址不在库里；</p>
      <p>超时未还 ：传来租车数据后长时间（超过24小时）没有还车记录的；</p>
      <p>异常站点 ：某个站点持续48小时以上没有租还数据的；</p>
      <p>故障车辆 ：某个车超过96小时没有人租还的；</p>
      <p>满桩还车 ：违反满桩禁停还车；</p>
      <p>非法车辆 ：未经政府审批违规投放的车辆；</p>
      <p>还车异常 ：出现出租状态上架、出租状态下架、出租状态出租；</p>
      <p>租车异常 ：出现还车状态归还、上架状态还车；</p>
      <p>下架异常 ：出现还车状态上架、上架状态上架；</p>
      <p>上架异常 ：出现下架状态出租、下架状态还车、下架状态下架；</p>
      <p>站外投车 ：车辆调度上架时企业上传的上架数据中出现没有站点编号或站点编号不在平台数据库。</p>
    </div>
  </div>
  <div style="height:305px;" v-show="showWarningText"></div>
  <div style="height:150px;" v-show="!showWarningText"></div>
  <div class="m16 pagination-bg-white" >
    <w-table :height="tableViewHeight" v-loading.body="tableLoading" :data-list="abnormalData" :columns="staticData.columns" :pageNo="formData.pageNum" :pageSize="formData.pageSize" :total="total" :pageSizes="[50,100,200]" @pageNoChange="pageNoChange" @pageSizeChange="pageSizeChange">
      <template slot-scope="props" slot="cell">
        <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span>
        <span v-else-if="props.column.label === '告警时间'">
          {{ props.row['updateTime'] | dateFormat('yyyy-MM-dd hh:mm:ss')}}
        </span>
        <span v-else-if="props.column.label === '告警类型'">
          <span :class="{
                'red': props.row['abnormalType'] === '1',
                'origin': props.row['abnormalType'] === '2',
                'warning': props.row['abnormalType'] === '3',
                'green': props.row['abnormalType'] === '4',
                'blue': props.row['abnormalType'] === '5',
                'pink': props.row['abnormalType'] === '6',
              }">
            {{ getAbnormalType(props.row['abnormalType'])}}
          </span>
        </span>
        <span v-else-if="props.column.label === '品牌名称'">
          {{ props.row['brandName']}}
        </span>
        <span v-else-if="props.column.label === '车辆编号'">
          {{ props.row['bikeId']}}
        </span>

        <span v-else-if="props.column.label === '车辆类型'">
          {{ getBikeType(props.row['bikeType'])}}
        </span>
        <span v-else-if="props.column.label === '告警地点'">
          <span @click="jjSearch(props.row)" class="cursor text-decoration" style="display:block;">{{ getShowText(props.row) }}</span>
        </span>
        <span v-else>{{ props.row[props.column.property]}}</span>
      </template>
    </w-table>
  </div>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import WTable from '@/components/Table/index.vue'
import Api from '@/api'
import {
  dateFormat,
  getFilterParams,
  lookPDF
} from '@/utils/tools'
import staticData from './staticData.js'
import {
  Loading
} from 'element-ui'

export default {
  props: ['companyData'],
  data() {
    return {
      size: 'small',
      formInline: {
        brandId: '',
        bikeId: '',
        abnormalType: '',
        bikeType: '',
        updateTime: [dateFormat(new Date().setDate(new Date().getDate()), 'yyyy-MM-dd'), dateFormat(new Date(), 'yyyy-MM-dd')]
      },
      abnormalTypes: [
        {
          label: '全部',
          key: ''
        },
        {
          label: '非法车辆',
          key: 7
        },
        {
          label: '站外还车',
          key: 1
        },
        {
          label: '故障车辆',
          key: 5
        },
        {
          label: '满桩还车',
          key: 6
        },
        {
          label: '异常站点',
          key: 4
        },
        {
          label: '超时未还',
          key: 3
        },
        {
          label: '违法设备',
          key: 2
        },
        {
          label: '不可投放站点上架',
          key: 8
        },
        {
          label: '还车异常',
          key: 9
        },
        {
          label: '租车异常',
          key: 10
        },
        {
          label: '上架异常',
          key: 11
        },
        {
          label: '下架异常',
          key: 12
        },
        {
          label: '站外投车',
          key: 13
        }
      ],
      tableLoading: false,
      abnormalData: [],
      total: 0,
      formData: {
        pageNum: 1,
        pageSize: 50
      },
      // companyDataWithAll: [],
      // 0-自行车，1-电动车
      bikeTypeList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '0',
          label: '自行车'
        },
        {
          value: '1',
          label: '电动车'
        }
      ],
      tableViewHeight: '',
      showWarningText: false
    }
  },
  computed: {
    ...mapGetters(['currpath', 'user', 'globaleSelfAreaId', 'siteMessage', 'selfAreaId', 'brands']),
    staticData() {
      return staticData
    },
    companyDataWithAll() {
      const companyDataWithAll = JSON.parse(JSON.stringify(this.brands))
      companyDataWithAll.unshift({
        brandName: '全部',
        brandId: ''
      })
      return companyDataWithAll
    }
  },
  created() {
    this.initData()
  },
  methods: {
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.warningLayoutHeader && this.$refs.warningLayoutHeader.clientHeight) {
          H += Number(this.$refs.warningLayoutHeader.clientHeight)
        }
        // console.log('H', H)
        // 56: 导航栏高度修正
        // 32: 底部padding修正
        this.tableViewHeight = window.innerHeight - 56 - H - 80
      })
    },
    getShowText(item) {
      let str = ''
      if (item.siteName) {
        str = item.siteName
      } else if (item.lon && item.lat) {
        str = `经度：${item.lon}，纬度：${item.lat}`
      }
      return str
    },
    closeHistory() {
      this.$emit('closeHistory')
    },
    jjSearch(item) {
      const vm = this
      // 满装还车-6，异常站点-4，跳转对应站点
      if (['6', '4'].includes(item.abnormalType) && item.siteId) {
        const loadingInstance = Loading.service({
          fullscreen: true,
          text: '站点搜索中...'
        })
        vm.closeHistory()
        loadingInstance.close()
        setTimeout(() => {
          vm.$router.push('/dailyDuty' + (vm.currpath.split('/')[2] ? ('/' + vm.currpath.split('/')[2]) : '') + '?siteId=' + item.siteId)
        }, 0)
      } else if (item.bikeId) {
        const loadingInstance = Loading.service({
          fullscreen: true,
          text: '站点搜索中...'
        })
        if (vm.currpath.indexOf('dailyDuty') === -1) {
          vm.$router.push('/dailyDuty' + (vm.currpath.split('/')[2] ? ('/' + vm.currpath.split('/')[2]) : ''))
        }
        setTimeout(() => {
          loadingInstance.close()
          vm.$emit('jjSearchFromHistory', item)
        }, 2000)
      } else {
        vm.$message.warning('该条数据存在问题，没有车辆编号！')
      }
    },
    initData() {
      const vm = this
      vm.tableLoading = true
      let params = {
        selfAreaId: vm.selfAreaId,
        currentPage: vm.formData.pageNum,
        pageSize: vm.formData.pageSize,
        bikeType: vm.formInline.bikeType
      }
      if (vm.formInline.updateTime && vm.formInline.updateTime[0] && vm.formInline.updateTime[1]) {
        params.startTime = new Date(vm.formInline.updateTime[0]).getTime()
        params.endTime = new Date(vm.formInline.updateTime[1]).getTime() + (23 * 60 * 60 + 59 * 60 + 59) * 1000
      }
      if (vm.formInline.brandId || Number(vm.formInline.brandId) === 0) {
        params.brandId = vm.formInline.brandId
      }
      if (vm.formInline.abnormalType || Number(vm.formInline.abnormalType) === 0) {
        params.abnormalType = vm.formInline.abnormalType
      }
      if (vm.formInline.bikeId || Number(vm.formInline.bikeId) === 0) {
        params.bikeId = vm.formInline.bikeId
      }
      params = getFilterParams(params)
      Api.getMsg(params)
        .then(res => {
          if (res.code === 200) {
            vm.abnormalData = res.data.lists
            vm.total = res.data.total
            vm.translate()
          } else {
            vm.$message.warning(res.message)
          }
          vm.calcView()
          vm.tableLoading = false
        })
    },
    translate() {
      const vm = this
      if (vm.abnormalData && vm.abnormalData.length) {
        vm.abnormalData.forEach(item => {
          if (vm.companyData && vm.companyData.find(it => Number(it.brandId) === Number(item.brandId))) {
            const brandName = vm.companyData.find(it => Number(it.brandId) === Number(item.brandId)).brandName
            vm.$set(item, 'brandName', brandName)
          }
        })
      }
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.initData()
    },
    pageSizeChange(size) {
      this.formData.pageSize = size
      this.initData()
    },
    onSearch() {
      this.initData()
    },
    onReset() {
      this.formInline.brandId = ''
      this.formInline.bikeId = ''
      this.formInline.abnormalType = ''
      this.formInline.updateTime = ''
    },
    onExport() {
      const vm = this
      let params = {
        selfAreaId: vm.selfAreaId,
        bikeType: vm.formInline.bikeType
      }
      if (vm.formInline.updateTime && vm.formInline.updateTime[0] && vm.formInline.updateTime[1]) {
        params.startTime = new Date(vm.formInline.updateTime[0]).getTime()
        params.endTime = new Date(vm.formInline.updateTime[1]).getTime() + (23 * 60 * 60 + 59 * 60 + 59) * 1000
      }
      if (vm.formInline.brandId || Number(vm.formInline.brandId) === 0) {
        params.brandId = vm.formInline.brandId
      }
      if (vm.formInline.abnormalType || Number(vm.formInline.abnormalType) === 0) {
        params.abnormalType = vm.formInline.abnormalType
      }
      if (vm.formInline.bikeId || Number(vm.formInline.bikeId) === 0) {
        params.bikeId = vm.formInline.bikeId
      }
      params = getFilterParams(params)
      Api.exportMsg(params)
        .then(res => {
          if (res.code === 200) {
            lookPDF(res.data)
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    getAbnormalType(type) {
      return {
        1: '站外还车',
        2: '违法设备',
        3: '超时未还',
        4: '异常站点',
        5: '故障车辆',
        6: '满桩还车',
        7: '非法车辆',
        8: '不可投放站点上架',
        9: '还车异常',
        10: '租车异常',
        11: '上架异常',
        12: '下架异常',
        13: '站外投车'
      }[String(type)]
    },
    getBikeType(type) {
      return {
        0: '自行车',
        1: '电动车'
      }[String(type)]
    }
  },
  components: {
    WTable
  }
}
</script>

<style scoped>
.mb3 {
  margin-bottom: 3px;
}

.warning-text p {
  font-size: 12px;
  color: #999;
}
.pink {
  color: #FF00FF;
}
.w120px {
  width: 120px;
}
.w200px {
  width: 200px;
}
.w250px {
  width: 250px;
}
.showWarningText {
  font-size: 15px;
  margin-left: 10px;
  color: #409EFF;
  cursor: pointer;
}
</style>
<style lang="less">
  .warning-show {
    .el-form-item__label {
      cursor: pointer;
    }
  }
  .abh {
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .el-select-dropdown__wrap {
    max-height: 100% !important;
  }
</style>
